<div class="content">
  <div class="form-login">
    <div class="main-title"><span>
      <a href="/">SatPhoneRecharge</a>
      <br/>
      confirmation
    </span></div>
    <hr class="dashed-line">
    <div *ngIf="email == null">
      <h2>Trwa potwierdzanie...</h2>
    </div>
    <form>
      <div *ngIf="email != null" class="input-control">
        <label for="email">Potwierdzono dla:</label>
        <input formControlName="email" id="email" maxlength="150" readonly type="text" value="{{ email }}"/>
      </div>

      <div *ngIf="email == null && refCode != null" class="input-control">
        <label for="refCode">Kod referencyjny</label>
        <input formControlName="refCode" id="email" maxlength="150" readonly type="text" value="{{ refCode }}"/>
      </div>

      <div *ngIf="email == null && code != null" class="input-control">
        <label for="code">Kod kontrolny</label>
        <input formControlName="code" id="code" maxlength="150" readonly type="text" value="{{ code }}"/>
      </div>
    </form>

    <div *ngIf="error != null">
      <h3>Błąd podczas potwierdzania użytkownika</h3>
      <p>{{ error }}</p>
    </div>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
